export const groupThreadsByDate = (threads, searchQuery, t) => {
  const filtered = threads.filter((thread) =>
    thread.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const groups = {
    today: [],
    yesterday: [],
    last7Days: [],
    older: [],
  };

  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterdayStart = new Date(todayStart);
  yesterdayStart.setDate(yesterdayStart.getDate() - 1);
  const sevenDaysAgoStart = new Date(todayStart);
  sevenDaysAgoStart.setDate(sevenDaysAgoStart.getDate() - 7);

  filtered.forEach((thread) => {
    const date = new Date(thread.created_at || thread.updated_at);
    if (date >= todayStart) {
      groups.today.push(thread);
    } else if (date >= yesterdayStart) {
      groups.yesterday.push(thread);
    } else if (date >= sevenDaysAgoStart) {
      groups.last7Days.push(thread);
    } else {
      groups.older.push(thread);
    }
  });

  return [
    { id: "today", title: t("chat.today"), data: groups.today },
    { id: "yesterday", title: t("chat.yesterday"), data: groups.yesterday },
    { id: "last7Days", title: t("chat.last_7_days"), data: groups.last7Days },
    { id: "older", title: t("chat.older"), data: groups.older },
  ].filter((group) => group.data.length > 0);
};
